import { Dispatch } from "react"
import { UploadTaskActionTypes } from "../action-types";
import { UploadTaskActions } from "../actions"
import { UploadTask } from "../../domain/uploadtask/uploadtask";

export const SendUploadTaskListRequest = () => {
    return async (dispatch: Dispatch<UploadTaskActions>) => {
        dispatch({
            type: UploadTaskActionTypes.UPLOADTASK_REQUEST_SEND,
          });
    }
}

export const UploadTaskListSuccess = (list: UploadTask[]) => {
    return async (dispatch: Dispatch<UploadTaskActions>) => {
        dispatch({
            type: UploadTaskActionTypes.UPLOADTASK_SUCCESS,
            payload: list,
        });
    }
}

export const UploadTaskListError = (error:string) => {
    return async (dispatch: Dispatch<UploadTaskActions>) => {
        dispatch({
            type: UploadTaskActionTypes.UPLOADTASK_ERROR,
            payload: error,
        });
    }
}

export const UploadTaskCreateRequest = () => {
    return async (dispatch: Dispatch<UploadTaskActions>) => {
        dispatch({
            type: UploadTaskActionTypes.UPLOADTASK_CREATE_REQUEST,
          });
    }
}

export const UploadTaskCreateSuccess = (uploadtask: UploadTask) => {
    return async (dispatch: Dispatch<UploadTaskActions>) => {
        dispatch({
            type: UploadTaskActionTypes.UPLOADTASK_CREATE_SUCCESS,
            payload: uploadtask,
          });
    }
}

export const UploadTaskCreateError = (message: string) => {
    return async (dispatch: Dispatch<UploadTaskActions>) => {
        dispatch({
            type: UploadTaskActionTypes.UPLOADTASK_CREATE_ERROR,
            payload: message,
          });
    }
}


export const UploadTaskUpdateRequest = () => {
    return async (dispatch: Dispatch<UploadTaskActions>) => {
        dispatch({
            type: UploadTaskActionTypes.UPLOADTASK_UPDATE_REQUEST,
          });
    }
}

export const UploadTaskUpdateSuccess = (category: UploadTask) => {
    return async (dispatch: Dispatch<UploadTaskActions>) => {
        dispatch({
            type: UploadTaskActionTypes.UPLOADTASK_UPDATE_SUCCESS,
            payload: category,
          });
    }
}

export const UploadTaskUpdateError = (message: string) => {
    return async (dispatch: Dispatch<UploadTaskActions>) => {
        dispatch({
            type: UploadTaskActionTypes.UPLOADTASK_UPDATE_ERROR,
            payload: message,
          });
    }
}


export const UploadTaskDeleteRequest = () => {
    return async (dispatch: Dispatch<UploadTaskActions>) => {
        dispatch({
            type: UploadTaskActionTypes.UPLOADTASK_DELETE_REQUEST,
          });
    }
}

export const UploadTaskDeleteSuccess = (id: UniqueId) => {
    return async (dispatch: Dispatch<UploadTaskActions>) => {
        dispatch({
            type: UploadTaskActionTypes.UPLOADTASK_DELETE_SUCCESS,
            payload: id,
          });
    }
}

export const UploadTaskDeleteError = (message: string) => {
    return async (dispatch: Dispatch<UploadTaskActions>) => {
        dispatch({
            type: UploadTaskActionTypes.UPLOADTASK_DELETE_ERROR,
            payload: message,
          });
    }
}